export function snapPct(v) {
  return Math.round(v * 100) / 100;
}

/**
 * Shared goal / progress / benchmark math for start-tracking style widgets.
 */
export function computeStartTrackingMetrics(goal, progress, todaysBenchmark) {
  const safeGoal = Number(goal) > 0 ? Number(goal) : 0;
  const safeProgress = Math.max(0, Number(progress) || 0);
  const safeBenchmark = Math.max(0, Number(todaysBenchmark) || 0);

  const fallbackGoal = safeProgress > 0 ? safeProgress * 10 : 0;

  const progressPct =
    safeGoal > 0
      ? snapPct(Math.min(100, (safeProgress / safeGoal) * 100))
      : fallbackGoal > 0
        ? snapPct(Math.min(100, (safeProgress / fallbackGoal) * 100))
        : 0;

  const benchmarkPct =
    safeGoal > 0
      ? snapPct(Math.min(100, (safeBenchmark / safeGoal) * 100))
      : 0;

  return {
    safeGoal,
    safeProgress,
    safeBenchmark,
    fallbackGoal,
    progressPct,
    benchmarkPct,
  };
}

export function alignForPercent(pct) {
  if (pct > 90) return "right";
  if (pct < 10) return "left";
  return "center";
}
